import styled from "styled-components";

export const ResponceMain = styled.div`
  margin: 20px 0px;
  padding: 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  font-size: 15px;
  font-weight: 500;
  color: rgb(32, 32, 79);

  .space-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3 {
      font-weight: 600;
      font-size: 20px;
      font-family: "Source Serif Pro", serif;
    }
    span {
      margin-top: -10px;
      margin-right: -7px;
      cursor: pointer;
      color: #666;

      .closeIco {
        font-size: 20px;
      }
    }
  }
  p {
    font-weight: 500;
    font-size: 15px;
  }
  ul {
    margin-top: 10px;
    li {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      list-style: none;
      font-size: 15px;
      font-weight: 500;
      margin-top: -5px;

      .dot {
        font-size: 30px;
        margin-right: -4px;
      }
    }
  }
  .button {
    padding: 3px 10px;
    background-color: rgb(58, 170, 53);
    width: 100%;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    margin-top: 10px;
    cursor: pointer;
  }
`;
